import { render, staticRenderFns } from "./express.vue?vue&type=template&id=5a74ae05&"
import script from "./express.vue?vue&type=script&lang=js&"
export * from "./express.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports